module.exports = __webpack_public_path__ + "img/calendar.5e7e22b9.svg";